import { makeStyles } from '@material-ui/core';
import {
    darkslategray,
    doveGray,
    dustyGray,
    royalblue,
    silver,
    white,
} from '../../../constants/Colors';
import candidatesSearchIcon from '../../../assets/image/candidates_search_icon.svg';

export default makeStyles(() => ({
    inputWrapper: {
        position: 'relative',
        marginRight: 15,
    },
    clearIcon: {
        position: 'absolute',
        top: '52%',
        right: 10,
        transform: 'translate(0, -50%)',
        padding: 10,
        cursor: 'pointer',
        color: doveGray,
        zIndex: 1,
    },
    candidatesSearchIcon: {
        position: 'absolute',
        cursor: 'pointer',
        color: doveGray,
        zIndex: 1,
        backgroundColor: darkslategray,
        top: 10,
        left: 10,
        width: 22,
        height: 20,
        maskSize: 'cover',
        maskImage: `url(${candidatesSearchIcon})`,
    },
    filterInput: {
        minHeight: 36,
        paddingLeft: 40,
        backgroundColor: white,
        border: `1px solid ${silver}`,
        borderRadius: 3,
        fontSize: '0.94rem',

        '&::placeholder': {
            color: dustyGray,
        },

        '&:focus': {
            border: `1px solid ${royalblue}`,
            outline: 'none',
        },
    },
    suggestions: {
        position: 'absolute !important',
        left: 0,
        top: 44,
        minWidth: 210,
        flex: 1,
        overflowY: 'scroll',
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '& > .suggeston-options': {
            position: 'relative !important',
            marginBottom: '0px !important',
            maxHeight: '580px !important',
        },
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.14), 0px 3px 4px rgba(0, 0, 0, 0.12), 0px 1px 5px rgba(0, 0, 0, 0.2)',
        scrollbarWidth: 'none',
        borderRadius: 3,
    },
    loader: {
        position: 'absolute',
        right: -170,
    },
}));
